import React, { useState } from 'react';
import { DateRange } from '@mui/x-date-pickers-pro';
import dayjs, { Dayjs } from 'dayjs';
import SecondaryButton from '../../components/buttons/secondaryButton';
import CustomDateRangePicker from '../../partials/customDateRangePicker/customDateRangePicker';
import { Colors } from '../../constants/constants';
import { ManualSyncDateRangeParams } from '../../apiHooks/mutations/internalSync/useSyncOrganizationByDateRange';

export const useInternalDateRange = () => {
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [filterRange, setFilterRange] = useState<DateRange<Dayjs>>([
    dayjs().subtract(1, 'month'),
    dayjs(),
  ]);

  const [from, to] = filterRange;
  const dateRangeParams: ManualSyncDateRangeParams = { from, to };
  const isDateRangeValid = Boolean(from?.isValid() && to?.isValid());

  return {
    filterRange,
    setFilterRange,
    isCalendarOpen,
    setIsCalendarOpen,
    dateRangeParams,
    isDateRangeValid,
  };
};

interface InternalDateRangePickerBarProps {
  dataCy: string;
  filterRange: DateRange<Dayjs>;
  setFilterRange: (range: DateRange<Dayjs>) => void;
  isCalendarOpen: boolean;
  setIsCalendarOpen: (open: boolean) => void;
}

export const InternalDateRangePickerBar: React.FC<InternalDateRangePickerBarProps> = ({
  dataCy,
  filterRange,
  setFilterRange,
  isCalendarOpen,
  setIsCalendarOpen,
}) => (
  <div className="mb-6 flex justify-start">
    <SecondaryButton
      type="button"
      className="relative"
      style={{
        paddingInline: '1rem',
        height: '40px',
        paddingBlock: 0,
        backgroundColor: 'white',
        border: `1px solid ${isCalendarOpen ? Colors.primary : '#eaeaea'}`,
      }}
      onMouseDown={() => setIsCalendarOpen(true)}
      dataCy={dataCy}
    >
      <CustomDateRangePicker
        filterRange={filterRange}
        setFilterRange={setFilterRange}
        isCalendarOpen={isCalendarOpen}
        setIsCalendarOpen={setIsCalendarOpen}
        iconButton
        showFilterDates
        anchorToTrigger
      />
    </SecondaryButton>
  </div>
);
